export const DEFAULT_STYLES = {
    '--color-primary-25': '#e5f2ff',
    '--color-primary-50': '#cce9ff',
    '--color-primary-100': '#99ceff',
    '--color-primary-200': '#66bdff',
    '--color-primary-300': '#33a7ff',
    '--color-primary-400': '#038cfc',
    '--color-primary-500': '#0563c7',
    '--color-primary-600': '#0a418f',
    '--color-primary-700': '#0a285c',
    '--color-primary-800': '#06132d',
    '--color-primary-900': '#020409',
  
    '--color-secondary-25': '#e8fcf0',
    '--color-secondary-50': '#d1fae2',
    '--color-secondary-100': '#a3f5be',
    '--color-secondary-200': '#77eea7',
    '--color-secondary-300': '#4ee494',
    '--color-secondary-400': '#2bd490',
    '--color-secondary-500': '#12ba6c',
    '--color-secondary-600': '#039654',
    '--color-secondary-700': '#02643b',
    '--color-secondary-800': '#03301d',
    '--color-secondary-900': '#010a06',

    '--color-button-primary': '#0563c7',
    '--color-glow': '#006eb7',
    '--color-login-background': '#f2f8ff',
    '--color-background-pages': '#fbfdff',
}

export const COLOR_STYLES_V2 = {
    '--color-primary-25': '#f0f7ff',
    '--color-primary-50': '#e5f1ff',
    '--color-primary-100': '#cce3ff',
    '--color-primary-200': '#99c5ff',
    '--color-primary-300': '#66a3ff',
    '--color-primary-400': '#3373e1',
    '--color-primary-500': '#0047ab',
    '--color-primary-600': '#003c8f',
    '--color-primary-700': '#003172',
    '--color-primary-800': '#002656',
    '--color-primary-900': '#001c3d',

    '--color-secondary-25': '#f2fdf6',
    '--color-secondary-50': '#e6fcef',
    '--color-secondary-100': '#d1fadf',
    '--color-secondary-200': '#a6f4c5',
    '--color-secondary-300': '#6dedab',
    '--color-secondary-400': '#37d88d',
    '--color-secondary-500': '#00d46a',
    '--color-secondary-600': '#00b559',
    '--color-secondary-700': '#00954a',
    '--color-secondary-800': '#00783c',
    '--color-secondary-900': '#005c2e',

    '--color-button-primary': '#0563c7',
    '--color-glow': '#0047ab',
    '--color-login-background': '#f0f7ff',
    '--color-background-pages': '#f0f7ff',

}